import api from '../api';

/**
 * Client mail — email to practices (SpoonFeed + Command Center). Every email
 * waits in the Approval Queue until an admin or DPM coordinator approves it.
 */
export const clientMailService = {
  /** { canUse, canApprove, canManageEvents, canManageSettings } — never refuses. */
  access: () => api.get('/client-mail/access'),
  list: (params) => api.get('/client-mail', { params }),
  summary: (params) => api.get('/client-mail/summary', { params }),
  locations: () => api.get('/client-mail/locations'),
  reviewers: () => api.get('/client-mail/reviewers'),
  get: (id) => api.get(`/client-mail/${id}`),
  /** { version, to, cc, bcc, subject, message | reviewNote, removeAttachments, addAttachments, confirmOtherRecipient } */
  edit: (id, body) => api.patch(`/client-mail/${id}`, body),
  /** Approve the version you saw. Automated → scheduled; manual → sent now. */
  approve: (id, version) => api.post(`/client-mail/${id}/approve`, { version }),
  /** [{ id, version }] — results per row. */
  bulkApprove: (items) => api.post('/client-mail/bulk-approve', { items }),
  reject: (id, version, reason) => api.post(`/client-mail/${id}/reject`, { version, reason }),
  followUp: (id) => api.post(`/client-mail/${id}/follow-up`),
  sendNow: (id) => api.post(`/client-mail/${id}/send-now`),
  cancel: (id) => api.post(`/client-mail/${id}/cancel`),
  /** Admin: one sample through the client SMTP, now (to the test recipient, else yourself). */
  sendTest: (to) => api.post('/client-mail/test-email', to ? { to } : {}),
  /** The eight notifications and their agency-wide switch — { events, onCount, total }. */
  listEvents: () => api.get('/client-mail/events'),
  /** Admin: { notification: boolean } (keys left out keep their state), or { all: boolean }. */
  saveEvents: (events) => api.put('/client-mail/events', { events }),
  /** Compose — the location, its allowed recipients, notifications off, the From address, whether mail can go. */
  manualContext: (clientId) => api.get('/client-mail/manual/context', { params: { clientId } }),
  manualPreview: (body) => api.post('/client-mail/manual/preview', body),
  manualDraft: (body) => api.post('/client-mail/manual/draft', body),
  /** Into the Approval Queue. Same `requestKey` = same email, never twice. */
  manualSubmit: (body) => api.post('/client-mail/manual/submit', body),
};
